module.exports = __webpack_public_path__ + "img/icone-dispositivo.611ab0b0.svg";